export const AUTHENTICATION_SIGN_IN = '/sign-in/';
export const AUTHENTICATION_SIGN_OUT = '/sign-out/';

export const CATALOG_INDEX = '/';

export const DASHBOARDS_INDEX = '/dashboards';

export const FOLDERS_INDEX = '/projects';
export const CONVERSATIONS_NEW = '/conversations/new/';

export const HELP_INDEX = 'https://help.mysidewalk.com/en/';
export const HELP_PRODUCT_UPDATES = 'https://help.mysidewalk.com/en/collections/79515-release-notes-updates';
export const HELP_DATA_UPDATES = 'https://help.mysidewalk.com/en/articles/4868311-data-library-updates-new-data';

export const LAYERS_INDEX = '/layers';
export const LAYERS_NEW_DRAW = '/layers/draw';
export const LAYERS_NEW_UPLOAD = '/layers/upload-options';

export const LEGAL_ACCEPTABLE_USE_POLICY = '/legal/acceptable-use-policy/';
export const LEGAL_PRIVACY_POLICY = '/legal/privacy-policy/';

export const REPORTS_INDEX = '/reports';

export const RESOURCES_WHEREHOUSE_INDEX = '/resources/wherehouse/';

export const TRAINING_INDEX = 'https://mysidewalk.talentlms.com';

export const USER_ORGANIZATION_INDEX = '/choose-an-organization';
export const USER_ORGANIZATION_SHOW = '/organization/';
export const USER_PREFERENCES = '/preferences/';

export const WORKSPACES_INDEX = '/workspaces/';
export const WORKSPACES_NEW_DATA_GUIDES = '/workspaces/new/data/guides/';
export const WORKSPACES_NEW_DATA_SEARCH = '/workspaces/new/data/search/';
